module.exports = __webpack_public_path__ + "static/img/vgg16_results1.7fb4a3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vgg16_results1.png
// module id = AZIp
// module chunks = 1